import { React, useState } from 'react'
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Text,
  useDisclosure,
  Lorem,
  Center,
  Box
} from '@chakra-ui/react'
import AddIcon from '@material-ui/icons/Add'
import './Modal.css'

function SubmitTrans(props) {
  const { isOpen, onOpen, onClose } = useDisclosure()
  return (
    <>
      <button className="left_deet_submit" onClick={onOpen}>
        Submit
      </button>

      <Modal className="ModalBody" blockScrollOnMount={false} isOpen={isOpen} onClose={onClose}>
        <ModalOverlay style={{ backgroundColor: 'rgba(0,0,0,0.5)', position: 'fixed' }} />
        <ModalContent
          style={{
            width: '30vw',
            height: '26vh',
            backgroundColor: '#fff',
            position: 'absolute',
            marginLeft: ' 35%',
            marginRight: 'auto',
            marginTop: '5%',
            borderRadius: '6px'
          }}
        >
          <ModalHeader style={{ marginLeft: '40px' }}>
            <p className="submitTrans_header">Confirme Claim</p>
          </ModalHeader>

          <ModalBody className="ModalBody">
            <p className="submitTrans_body">
              Você está prestes a enviar uma claim com ({props.transNums}) transações. Por favor,
              confirme que esta claim é para ({props.memberDetails.first_names}{' '}
              {props.memberDetails.last_name}){' '}
            </p>
          </ModalBody>

          <ModalFooter>
            <button className="submitTrans_cancel" onClick={onClose}>
              Cancel
            </button>

            <button
              className="submitTrans_confirm"
              onClick={() => {
                props.submitTrans()
                onClose()
              }}
            >
              Yes, Confirm
            </button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}

export default SubmitTrans
